import { render, staticRenderFns } from "./AverageTimeCalls.vue?vue&type=template&id=1c3bbbb6"
import script from "./AverageTimeCalls.vue?vue&type=script&lang=js"
export * from "./AverageTimeCalls.vue?vue&type=script&lang=js"
import style0 from "./AverageTimeCalls.vue?vue&type=style&index=0&id=1c3bbbb6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports